const SmallGreenCoinIcon = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7465 41.7454C28.6521 44.3526 38.8424 38.3182 41.5594 28.3578C44.2764 18.3974 38.5229 8.16658 28.6173 5.55938C18.7117 2.95218 8.52147 8.98658 5.80447 18.947C3.08748 28.9074 8.8409 39.1382 18.7465 41.7454Z"
        fill="#021024"
        fillOpacity="0.1"
      />
      <path
        d="M17.6518 40.544C27.4757 43.1297 37.6143 37.148 40.321 27.2253C43.0277 17.3027 37.2922 7.14276 27.4683 4.55706C17.6443 1.97136 7.50568 7.95309 4.79898 17.8758C2.09228 27.7984 7.82783 37.9583 17.6518 40.544Z"
        fill="#8DBBBB"
        stroke="#079391"
        strokeWidth="2"
      />
      <path
        d="M16.5307 39.4425C26.3546 42.0282 36.4932 36.0464 39.1999 26.1238C41.9066 16.2011 36.1711 6.04119 26.3472 3.45549C16.5232 0.869795 6.38459 6.85153 3.67789 16.7742C0.971189 26.6969 6.70674 36.8568 16.5307 39.4425Z"
        fill="#7DC1B9"
        stroke="#079391"
        strokeWidth="2"
      />
      <path
        d="M17.402 36.249C25.4375 38.364 33.7261 33.4201 35.9499 25.2677C38.1737 17.1152 33.5121 8.76279 25.4766 6.64781C17.4411 4.53284 9.15254 9.47674 6.92872 17.6292C4.70491 25.7816 9.36651 34.134 17.402 36.249Z"
        fill="#CAEAE9"
        stroke="#079391"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.8495 11.637C30.3089 10.2888 28.4458 9.26998 26.3355 8.71454C18.8556 6.7458 11.1022 11.3443 9.01783 18.9857C7.67259 23.9173 9.01737 28.911 12.151 32.3617C8.23112 28.9314 6.39926 23.3691 7.89558 17.8836C9.97998 10.2423 17.7334 5.64378 25.2132 7.61252C27.8657 8.31066 30.1276 9.74091 31.8495 11.637Z"
        fill="#EBF3FF"
      />
      <path
        d="M17.5137 5.51527C12.304 6.92767 8.10772 10.7394 6.23429 15.6641"
        stroke="#CBECEC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.1816 35.222C32.1596 33.9301 33.8433 32.2381 35.1131 30.2637"
        stroke="#CBECEC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9048 8.22754C11.9048 8.22754 10.2223 9.32938 9.10059 10.9821"
        stroke="#FEFFFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.148 10.9814C14.148 10.9814 12.4655 12.0833 11.3438 13.736"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SmallGreenCoinIcon;
